import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { ThrowStmt } from "@angular/compiler";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, ReplaySubject, Subject, throwError } from "rxjs";
import { Facility } from "../models/facility.model";
import { map, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SharedStateService {
  passChange1(payload: { CurrentPassword: any; NewPassword: any; ConfirmPassword: any; }) {
    throw new Error("Method not implemented.");
  }
  private patientDocument = new BehaviorSubject([{}]);
  currentPatientDocument = this.patientDocument.asObservable();

  public updatePatientDocument(message: Array<any>) {
    this.patientDocument.next(message);
  }
  // public shareFacility: ReplaySubject<any[]> = new ReplaySubject();
  public GetLanguageAPIMethod = "lookups/dbo/new";
  public PrimaryState: any = {
    login: {
      email: null,
    },
    prescriberInfo: {
      firstName: null,
      lastName: null,
      username: null,
      npi: null,
      data: null,
      facilities: [],
      portalAccountPkId: null
    },
  };
  public UserInfoData: any = {}
  public resHeaders: HttpHeaders = new HttpHeaders()
    .set("Accept", "application/json")
    .set("Content-Type", "application/json")
    // .set("ClientId", "V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH")
    .set("ProgramId", environment.programId)
  constructor(
    @Inject("API_URL") private apiUrl: any,
    @Inject("API_URL_DOC") private apiUrlDoc: any,
    @Inject("ECONSENT_URL") private apiEConsentUrl: any,
    private http: HttpClient
  ) { }
  //*****************************/
  // public getPrescriptionOrder(): Promise<any> {
  //     let ans;
  //    let url: string = `https://ext-api.pharmacord.com/portaldev/api/v1.0/pharmacy/programPharmacy?dispensingType=2&pharmacyType=2&drugGroupId=1&fulfillmentItemTypeValue=Paid%20Drug`;
  //  return this.http.get<any>('https://ext-api.pharmacord.com/portaldev/api/v1.0/pharmacy/programPharmacy?dispensingType=2&pharmacyType=2&drugGroupId=1&fulfillmentItemTypeValue=Paid%20Drug').toPromise().then(data => {return data;});
  // }
  //*****************************//
  public forgotUsername: boolean = false;
  // public forgotUser(){
  //   return this.forgotUsername;
  // }
  public validatePrescriber(npi: string): Promise<any> {
    let url: string = `${this.apiUrl.baseUrl}provider/${npi}`;
    return this.http
      .get<any>(url, {
        headers: this.resHeaders,
      })
      .toPromise()
      .then((resp) => {
        this.PrimaryState.prescriberInfo = {
          ...this.PrimaryState.prescriberInfo,
          data: resp.Payload[0],
        };
        return resp;
      });
  }
  public validateNpi(npi: string): Promise<any> {
    let url: string = `${this.apiUrl.baseUrl}prescriber/lookups/npi/${npi}`;
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set(
      "Authorization",
      "Bearer " + jwtToken
    );
    return this.http
      .get<any>(url, {
        headers: headers,
      })
      .toPromise()
      .then((resp) => {
        console.log(resp);

        return resp;
      });
  }
  public resetPasswordSecurityQuestions(): Observable<any> {
    //let securityQues:string = `${this.apiUrl.baseUrl}provider/cases/${this.PrimaryState.prescriberInfo.providerId}`; 
    let securityQues: any = [{
      "id": 1,
      "question": "In what city were you born?"
    },
    {
      "id": 2,
      "question": "What is your pet’s name?",
    },
    {
      "id": 3,
      "question": "What is your mother’s maiden name?"
    }]
    //return this.http.get<any>(securityQues);
    return securityQues;
  }
  public getSecurityQuestions(): Observable<any> {
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + jwtToken)
      // .set('ClientId', 'V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH')
    return this.http.get<any>(`${this.apiUrl.baseUrl}portal/securityQuestion`, {
      headers: headers,
    })
  }

  public getSecurityQuestionsbyId(PortalAccountPkId): Observable<any> {
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + jwtToken)
    // .set('ClientId', 'V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH')
    return this.http.get<any>(`${this.apiUrl.baseUrl}portal/account/securityQuestion/${PortalAccountPkId}`, {
      headers: headers,
    })
  }
  public getPdfData(docId: string,caseId,username): Observable<any> {
    const host = environment.pdfHost;
    let url: string = `${host}/api/v1.1/documents/${username}/${caseId}/${docId}`;
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set(
      "Authorization",
      "Bearer " + jwtToken
    );
    return this.http.get(url, {
      headers: headers,
      responseType: "arraybuffer" as "json",
    });
  }
  public registerAccount(payload: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}account`;

    return this.http.post<any>(url, payload, {
      headers: this.resHeaders,
    });
  }
  public registerProvider(payload: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}provider`;
    return this.http.post<any>(url, payload, {
      headers: this.resHeaders,
    });
  }

  public deleteProvider(payload: any, pkId: any): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}portal/account/deleteProvider/${pkId}`;
    return this.http.put<any>(url, payload, {
      headers: headers,
    });
  }

  public deleteProviderFacilities(payload: any): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrl.baseUrl}portal/delete/prescriberFacility`;
    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }

  public getFacilities(): Facility[] {
    return (
      this.PrimaryState.prescriberInfo.facilities ||
      this.PrimaryState.prescriberInfo.data[0].Facilities
    );
  }
  public sendFacilities(payload: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}account`;

    return this.http.post<any>(url, payload, {
      headers: this.resHeaders,
    });
  }
  public sendQuestions(payload: any): Observable<any> {
    let jwtToken = localStorage.getItem("jwt");
    let url: string = `${this.apiUrl.baseUrl}securityQuestion/save`;
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + jwtToken)
      // .set('ClientId', 'V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH')
    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }
  public caseLoad(): any[] {
    return [
      {
        patientId: "100000009",
        patientFirstName: "John",
        patientLastName: "Glen",
        dob: "03/22/1967",
        gender: "Male",
        caseId: "DM4993",
        caseType: "PAP",
        startDate: "08/15/2020",
        caseStatus: "Closed",
        description: "PAP Shipped",
      },
      {
        patientId: "100000008",
        patientFirstName: "Christy",
        patientLastName: "Taylor",
        dob: "03/22/1960",
        gender: "Female",
        caseId: "DM4888",
        caseType: "Case Management",
        startDate: "08/21/2020",
        caseStatus: "Open",
        description: "Bill In Process",
      },
      {
        patientId: "100000088",
        patientFirstName: "Patty",
        patientLastName: "Glen",
        dob: "03/22/1972",
        gender: "Female",
        caseId: "DM4987",
        caseType: "PAP",
        startDate: "08/15/2020",
        caseStatus: "Closed",
        description: "PAP Shipped",
      },
      {
        patientId: "100000077",
        patientFirstName: "Henry",
        patientLastName: "James",
        dob: "03/22/1970",
        gender: "Male",
        caseId: "DM4902",
        caseType: "PAP",
        startDate: "09/15/2020",
        caseStatus: "In Progress",
        description: "PAP Shipped",
      },
      {
        patientId: "100000088",
        patientFirstName: "Eva",
        patientLastName: "Jones",
        dob: "03/22/1976",
        gender: "Female",
        caseId: "DM4911",
        caseType: "PAP",
        startDate: "09/22/2020",
        caseStatus: "In Progress",
        description: "PAP Shipped",
      },
    ];
  }
  public caseAlertsData(): any[] {
    return [
      {
        patientId: "100000009",
        patientFirstName: "John",
        patientLastName: "Glen",
        caseId: "DM4993",
        alertDateTime: "08/21/2020 08:30 AM",
        alertType: "PA_PE",
        description: "Written PA is required for Humana",
        resolution: "Resolved - Removed Alert",
      },
      {
        patientId: "100000009",
        patientFirstName: "Jane",
        patientLastName: "Doe",
        caseId: "DM4888",
        alertDateTime: "08/21/2020 08:30 AM",
        alertType: "PA_PE",
        description: "Written PA is required for Humana",
        resolution: "Resolved - Removed Alert",
      },
    ];
  }
  public getClaimHistory(): any[] {
    return [
      {
        claimId: "3123123",
        claimDate: "08/08/2020",
        productService: "Gadovante",
        locationType: "Specialty Pharmacy",
        location: "CVS Pharmacy",
        quantity: 90,
        initialOOP: 70.0,
        amtPaid: 50.0,
        patientOOP: 20.0,
      },
      {
        claimId: "3123411",
        claimDate: "08/21/2020",
        productService: "Gadovante",
        locationType: "Specialty Pharmacy",
        location: "CVS Pharmacy",
        quantity: 90,
        initialOOP: 70.0,
        amtPaid: 50.0,
        patientOOP: 20.0,
      },
    ];
  }
  public getPrescriptionHistory(): any[] {
    return [
      {
        rxId: "093992002",
        writtenDate: "08/08/2020",
        drug: "Gavonventen 15mg Tab",
        ndc: "5555-4444-22",
        sig: "Take One Tablet",
        quanity: 240,
        refills: 8,
        remaining: 150,
        refillsRemaining: 5,
        status: "Active",
      },
      {
        rxId: "094442002",
        writtenDate: "08/20/2020",
        drug: "Gavonventen 15mg Tab",
        ndc: "5555-4444-22",
        sig: "Take One Tablet",
        quanity: 240,
        refills: 8,
        remaining: 100,
        refillsRemaining: 5,
        status: "Active",
      },
    ];
  }
  public loginUser(userData: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}account/login`;

    let mockUserData = {
      Email: userData.email,
      Password: userData.password,
    };
    this.PrimaryState.prescriberInfo.username=mockUserData.Email;
    this.PrimaryState.login.email = mockUserData.Email;
    return this.http.post<any>(url, mockUserData, {
      headers: this.resHeaders,
    }).pipe(
      catchError(this.handleError)
    );
  }

  public postProfile(userData: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}portal/account/person/update`;
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + jwtToken)

    return this.http.post<any>(url, userData, {
      headers: headers,
    });
  }

  public getEsignatureStatus(portalAccountPkId: number): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}idme/status/${portalAccountPkId}`;
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + jwtToken)

    return this.http.get<any>(url, {
      headers: headers,
    }).pipe(catchError((error: any) => {
      throw error;
    })
    )
  }


  public usernameReset(payload: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}portal/account/forgotUsername`;
    return this.http.post<any>(url, payload, {
      headers: this.resHeaders,
    });
  }
  public submitForm(userData: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}account/login`;

    return this.http.post<any>(url, userData, {
      headers: this.resHeaders,
    });
  }

  public changePass(userpass: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}portal/account/person/updatePassword`;
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + jwtToken)
    return this.http.post<any>(url, userpass, {
      headers: headers,
    });
  }
  // https://ext-api.pharmacord.com/portaldev/api/v1.0/securityQuestion/save

  public postQuesAns(quesans: any): Observable<any> {
    let jwtToken = localStorage.getItem("jwt");
    let url: string = `${this.apiUrl.baseUrl}portal/account/answerSecurityQuestionUpdate `;
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + jwtToken)
    //.set('ClientId','V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH')
    return this.http.post<any>(url, quesans, {
      headers: headers,
    });
  }
  public passwordReset(payload: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}securityQuestions?userName=${payload.UserName}&email=${payload.EmailAddress}`;
    // let url:string = 	`https://ext-api.pharmacord.com/portaldev/api/v1.0/securityQuestions?userName=${payload.UserName}&email=${payload.EmailAddress}`;
    // let url: string = `${this.apiUrl.baseUrl}account/password/reset/initiate`;

    return this.http.get<any>(url, {
      headers: this.resHeaders,
    });
  }
  // public forceResetPassword(payload: any): Observable<any> {
  //   let url: string = `${this.apiUrl.baseUrl}account/person/updatePassword`;
  //   let jwtToken = localStorage.getItem("jwt");
  //   const headers = new HttpHeaders()
  //     .set('Authorization', 'Bearer ' + jwtToken)
  //   return this.http.post<any>(url, payload, {
  //     headers: headers,
  //   });
  // }
  public passwordConfirm(payload: any): Observable<any> {
    // http://localhost:8082/api/v1.0/portal/account/resetPassword 
    let url: string = `${this.apiUrl.baseUrl}portal/account/resetPassword`;

    return this.http.post<any>(url, payload, {
      headers: this.resHeaders,
    });
  }
  public securityQues(payload: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}account/password/reset/initiate`;

    return this.http.post<any>(url, payload, {
      headers: this.resHeaders,
    });
  }
  // public verificationQuestions(payload: any): Observable<any> {
  //   let url: string = `${this.apiUrl.baseUrl}account/questions/reset/initiate`;

  //   return this.http.post<any>(url, payload, {
  //     headers: this.resHeaders,
  //   });
  // }
  public getAccountInfo(username: string): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}account/${username}?ShowAccountIndicator=True`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }
  // public getEconsentAuthentication(): Observable<any> {
  //   // let t = localStorage.getItem("jwt");
  //   let authenticatePayload = {
  //     ClientId: "hk8BLnCw3dS7rQFa38lfBo0jbSGxwdyG",
  //     ClientSecret: "hdvM238YGty-SRTHy9PEM1nsuWXpxiUJ28746wJ1c1LK3230rRxVI0WW9wBxCKo5",
  //     Audience: "https://extcaps.pharmacord.com/api/v1",
  //     GrantType: "client_credentials"
  //   }
  //   console.log(this.apiEConsentUrl)
  //   let headers = this.resHeaders;
  //   let url: string = `${this.apiEConsentUrl.baseUrl}security/v1.0/authenticate`;
  //   return this.http.post<any>(url, authenticatePayload, {
  //     headers: headers,
  //   });
  // }

  public postEconsentDetails(econsentDetailPayload: object): Observable<any> {
    let Payload = econsentDetailPayload
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Authorization', AuthorizationToken);
    let url: string = `${this.apiEConsentUrl.baseUrl}api/v1.1/website/public/enrollCase`;
    return this.http.post<any>(url, Payload, {
      headers: this.resHeaders,
    });
  }


  public getUserFacilities(id: string): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrl.baseUrl}portal/facilities?portalAccountId=${id}`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }

  public getSignedDocument(CaseID: string): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrl.baseUrl}documents/signed/content/${CaseID}?docType=RF - Izervay My Way HCP Portal Enrollment`;
    return this.http.get<any>(url, {
      headers: headers,
      responseType: "arraybuffer" as "json",
    });
  }

  public getProviderCases(): Observable<any> {
    let newUrl: string = `${this.apiUrl.baseUrl}provider/cases/prescriber?prescriberIds=${this.PrimaryState.prescriberInfo.providerId}&masterPortalAccountId=${this.providerAccountId}`;
    let url: string = `${this.apiUrl.baseUrl}provider/cases/${this.PrimaryState.prescriberInfo.providerId}`;
    return this.http.get<any>(newUrl);
  }
  // public securityQues():Observable<any>{
  //   let quesList: string= `https://ext-api.pharmacord.com/portaldev/api/v1.0/portal/securityQuestion`;
  //   return this.http.get<any>(quesList);
  // }

  public getProviderMessages(): Observable<any> {
    const username = this.PrimaryState.prescriberInfo.username;
    let url: string = `${this.apiUrl.baseUrl}messages/${username}`;
    return this.http.get<any>(url);
  }
  public getCasesDetails(caseId: string): Observable<any> {
    const username = localStorage.getItem('username')
    let url: string = `${this.apiUrl.baseUrl.replace('v1.0', 'v1.1')}case/${username}/${caseId}`;
    return this.http.get<any>(url);
  }
  public getCaseAlerts(): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}provider/case/alerts/${this.PrimaryState.prescriberInfo.providerId}`;
    return this.http.get<any>(url);
  }
  public acknowledge(caseId, id): Promise<any> {
    let url: string = `${this.apiUrl.baseUrl}cases/alerts/${caseId}/${id}`;
    let jwtToken = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${jwtToken}`
    );
    return this.http
      .delete<any>(url, {
        headers: headers,
      })
      .toPromise()
      .then((resp) => {
        return resp;
      });
  }
  // public checkIfEmailUsed(username: string): Promise<any> {
  //   let url: string = `${this.apiUrl.baseUrl}account/${username}/inuse`;
  //   return this.http
  //     .get<any>(url, {
  //       headers: {},
  //     })
  //     .toPromise()
  //     .then((resp) => {
  //       return resp;
  //     });
  // }
  public updatePwdEmail(
    Id: string,
    pwd: string,
    confirmPwd: string,
    username: string
  ): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}facilityAccount/password/reset`;
    const finalPayload = {
      Username: username,
      Password: pwd,
      PasswordConfirmation: confirmPwd,
      UUID: Id,
    };
    return this.http.post<any>(url, finalPayload, {
      headers: this.resHeaders,
    });
  }
  public getUsernameUUID(uuid: string): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}facilityAccount/password/reset/${uuid}`;
    return this.http.get<any>(url);
  }
  public updatePwd(
    pwd: string,
    pwdConfirmation: string,
    oldPwd: string
  ): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}facilityAccount/password/update`;
    const finalPayload = {
      Username: this.PrimaryState.prescriberInfo.username,
      Password: pwd,
      PasswordConfirmation: pwdConfirmation,
      OldPassword: oldPwd,
    };
    return this.http.post<any>(url, finalPayload, {
      headers: this.resHeaders,
    });
  }
  public sendMessage(
    subject: string,
    body: string,
    messageId: string
  ): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}messages`;
    const finalPayload = {
      Username: this.PrimaryState.prescriberInfo.username,
      Subject: subject,
      Body: body,
      MessageThreadId: messageId ? messageId : null,
    };
    return this.http.post<any>(url, finalPayload, {
      headers: this.resHeaders,
    });
  }
  public addNote(caseId: string, noteToAdd: string): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}notes`;
    const finalUpload = {
      CaseId: caseId,
      Text: noteToAdd,
    };
    return this.http.post<any>(url, finalUpload, {
      headers: this.resHeaders,
    });
  }
  public uploadDocument(
    fileToUpload: File,
    caseId: string,
    patientId: string
  ): Observable<any> {
    //const fileHeaders: HttpHeaders = new HttpHeaders().set('Content-Type', 'multipart/form-data');
    const fileHeaders: HttpHeaders = new HttpHeaders();
    let url: string = `${this.apiUrl.baseUrl}documents`;
    const formData: FormData = new FormData();
    formData.append("Document", fileToUpload);
    formData.append("CaseId", caseId);
    formData.append("PatientId", patientId);
    return this.http.post<any>(url, formData, {
      headers: fileHeaders,
    });
  }
  public hasState(): boolean {
    return (
      this.PrimaryState.prescriberInfo && this.PrimaryState.prescriberInfo.data
    );
  }
  public clearState(): void {
    this.PrimaryState = {
      login: {
        email: null,
      },
      prescriberInfo: {
        firstName: null,
        lastName: null,
        username: null,
        npi: null,
        data: null,
        facilities: [],
      },
    };
  }

  // Method SERvice for new REgistration
  public userRegistration(payload: any): Observable<any> {
    //let t = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik5EbERNRE13UmpVM1JqQkNNalUwTkVFeE1UbEVPREl5UWtNME9EVTFPRGxGTUVWR1JETkdOUSJ9.eyJpc3MiOiJodHRwczovL3BoYXJtYWNvcmQuYXV0aDAuY29tLyIsInN1YiI6ImMwdkltN2JMeXRpeG9Md0NhMnRRMndGMHdOemxRSjcyQGNsaWVudHMiLCJhdWQiOiJodHRwczovL2NhcHMucGhhcm1hY29yZC5jb20vYXBpL3YxIiwiaWF0IjoxNjQyMzQ0MDQ4LCJleHAiOjE2NDI0MzA0NDgsImF6cCI6ImMwdkltN2JMeXRpeG9Md0NhMnRRMndGMHdOemxRSjcyIiwic2NvcGUiOiJ0cmlhZ2U6cmVhZCB0cmlhZ2U6d3JpdGUgc3lzdGVtLWFwaTp3cml0ZSBzeXN0ZW0tYXBpOnJlYWQiLCJndHkiOiJjbGllbnQtY3JlZGVudGlhbHMifQ.4EHwcmmb8miP-pIn2lOgmib7PGh8saKLqCJaVrR9KXtbu1upcKQVGZD1QLSqDNUMAPWMjerP9X4WYEYUfJBIYZ-UGAXTCUQw8uFur1gdEzxoAzluHK3mnMXtDfpl48b31JIv701DpUzpOiKLUNaW4utofBBFGIgFzXco4vWDH2EUGK2mEmtv0-EEf6TZMJqWIJGOs33Re_TS4BNXVShdyAWZSlKDBPdSedEL24KqjYUlLtKAxZSdA1GDPuBsWoVnsyz_g32PpTPWNgl8l7M2zXqQGb1rtgE9ko1koZIAMCum-d1EN8Zh_uSZnzicGw8aEXtB4Q3HcLU_H0Y-gugeIA";
    const headers = new HttpHeaders()
      .set("Access-Control-Allow-Origin", "*")
      .set(
        "Access-Control-Allow-Headers",
        "Origin, X-Requested-With, Content-Type, Accept"
      );

    // let t = new HttpHeaders().set("Authorization", "Bearer " + "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik5EbERNRE13UmpVM1JqQkNNalUwTkVFeE1UbEVPREl5UWtNME9EVTFPRGxGTUVWR1JETkdOUSJ9.eyJpc3MiOiJodHRwczovL3BoYXJtYWNvcmQuYXV0aDAuY29tLyIsInN1YiI6ImMwdkltN2JMeXRpeG9Md0NhMnRRMndGMHdOemxRSjcyQGNsaWVudHMiLCJhdWQiOiJodHRwczovL2NhcHMucGhhcm1hY29yZC5jb20vYXBpL3YxIiwiaWF0IjoxNjQyMjUzNzIwLCJleHAiOjE2NDIzNDAxMjAsImF6cCI6ImMwdkltN2JMeXRpeG9Md0NhMnRRMndGMHdOemxRSjcyIiwic2NvcGUiOiJ0cmlhZ2U6cmVhZCB0cmlhZ2U6d3JpdGUgc3lzdGVtLWFwaTp3cml0ZSBzeXN0ZW0tYXBpOnJlYWQiLCJndHkiOiJjbGllbnQtY3JlZGVudGlhbHMifQ.48MQRyK6jN5STv3qu28SopC_GwOTAXsOC67TfxZgZ6tkGJiPcJelxF8kpKWcitqBUsl6F3gLnILmip93R2dqseNFWXkxPt9OyBI12qFWYCgzieSjtsQrjP4fSdSyYOmZaaRRUPDi3Agr2h8HDFG4zWu46XQiIEdjFAPAL5TMdnwwDdkswhvmKUPp1kOYQ285v9KOV85I060b3Ttr5eMG1hyMIcYgPFCakgKCk1zTCmO6nD4uzyuwDw8smOjLwMM0Frh4SvRgLnQIobnGFV_FmzTVRyvJDbaeRmr5VTGbjrDkkDtMfrb5JnqNei9DyiQ88nt5BQwg-6lGS_P7O3_hYw");

    // let headers_object = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //    'Authorization': "Bearer " + t,
    //    'Access-Control-Allow-Origin' : 'http://localhost:9843/'
    // });

    const myJSON = JSON.stringify(payload);

    let url: string = `${this.apiUrl.baseUrl}account`;

    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }

  headerLogo = new Subject<any>();
  loginUserInfo = new Subject<any>();
  providerAccountId: any;
  userdetails: any = [];
  url = "assets/Json/";

  /**
   *
   * @returns Get Country State Details
   */
  getState() {
    let ConstantURLs = this.url + "state.json";
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    let params = new HttpParams();
    return this.http
      .get(ConstantURLs, { headers: headers })
      .pipe(
        catchError((error: any) => {
          this.getStateDataError(error);
          throw error;
        })
      )
      .pipe(map((response: Response) => response));
  }
  errorApiCatch: any;
  getStateDataError(err: Response) {
    if (
      err.status === 201 ||
      err.status === 500 ||
      err.status === 404 ||
      err.status === 406
    ) {
      this.errorApiCatch = err.statusText;
      // return this.apigetstateDetails.next(this.errorApiCatch);
    }
  }

  /**
   * API call to get All Languages
   * @returns array of languages
   */
  getLanguagesList() {
    const url = `${this.apiUrl.baseUrl}${this.GetLanguageAPIMethod}`;
    const token = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

    return this.http.get<any>(url, {
      params: { lookupNames: "Language" },
      headers: headers,
    });
  }

  /**
   *
   * @returns Get Physician Address Details
   */
  getPhysicianDetails() {
    let ConstantURLs = this.url + "physicianinfo.json";
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    let params = new HttpParams();
    return this.http
      .get(ConstantURLs, { headers: headers })
      .pipe(
        catchError((error: any) => {
          this.getPhysicianDataError(error);
          throw error;
        })
      )
      .pipe(map((response: Response) => response));
  }
  errorphysicianApiCatch: any;
  getPhysicianDataError(err: Response) {
    if (
      err.status === 201 ||
      err.status === 500 ||
      err.status === 404 ||
      err.status === 406
    ) {
      this.errorphysicianApiCatch = err.statusText;
      // return this.apigetstateDetails.next(this.errorphysicianApiCatch);
    }
  }

  /**
   *
   * @returns Get Physician details Acccording to Physician ID
   */
  getPhysicianAddressInfo() {
    let ConstantURLs = this.url + "physicianinfoDetails.json";
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    let params = new HttpParams();
    return this.http
      .get(ConstantURLs, { headers: headers })
      .pipe(
        catchError((error: any) => {
          this.getPhysicianAddressDataError(error);
          throw error;
        })
      )
      .pipe(map((response: Response) => response));
  }
  errorphysicianAddressApiCatch: any;
  getPhysicianAddressDataError(err: Response) {
    if (
      err.status === 201 ||
      err.status === 500 ||
      err.status === 404 ||
      err.status === 406
    ) {
      this.errorphysicianAddressApiCatch = err.statusText;
      // return this.apigetstateDetails.next(this.errorphysicianAddressApiCatch);
    }
  }

  public getProvidersDetails(
    hcpNPI,
    hcpFirstName,
    hcpLastName
  ): Observable<any> {
    // let t = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik5EbERNRE13UmpVM1JqQkNNalUwTkVFeE1UbEVPREl5UWtNME9EVTFPRGxGTUVWR1JETkdOUSJ9.eyJpc3MiOiJodHRwczovL3BoYXJtYWNvcmQuYXV0aDAuY29tLyIsInN1YiI6ImMwdkltN2JMeXRpeG9Md0NhMnRRMndGMHdOemxRSjcyQGNsaWVudHMiLCJhdWQiOiJodHRwczovL2NhcHMucGhhcm1hY29yZC5jb20vYXBpL3YxIiwiaWF0IjoxNjQyNzY0OTExLCJleHAiOjE2NDI4NTEzMTEsImF6cCI6ImMwdkltN2JMeXRpeG9Md0NhMnRRMndGMHdOemxRSjcyIiwic2NvcGUiOiJ0cmlhZ2U6cmVhZCB0cmlhZ2U6d3JpdGUgc3lzdGVtLWFwaTp3cml0ZSBzeXN0ZW0tYXBpOnJlYWQiLCJndHkiOiJjbGllbnQtY3JlZGVudGlhbHMifQ.vpbLRcZ5UI-X2209OkAIHvYY6RD5jev7r-PIdVYfAUY6w8xWiwMWQ7l7cEq5JcCJgsZ1cif2pZBIFkXRvTgDpNgcwQOXjz1c4DRZ201wI6nkn9mo7A0r91ViFbdkKxbPnTfQyDAbshoQjz-O4-l1O3s92fdG-LVzNQEyTkDlGeV5ZWfLmC-1czoKcZhl95KPNHtl6SCvNSxzA2UK7_F4HQ3CQN6TS8XV0A9CqirofukXC3vAcss0BYfIxZ_ueQJQPTB48GeGi4xxKRBV5ev45IOGMgbzpCazA4zPvRTIQveOvjYKLozfOru24-KNNRAOJBsn-jN2BAFlLzZK_3bjeQ";
    const headers = new HttpHeaders()
      .set("Access-Control-Allow-Origin", "*")
      // .set('Authorization', 'Bearer ' + t)
      // .set("ClientId", "V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH")
      .set(
        "Access-Control-Allow-Headers",
        "Origin, X-Requested-With, Content-Type, Accept"
      );

    let url: string = `${this.apiUrl.baseUrl}provider/${hcpNPI}/${hcpFirstName}/${hcpLastName}`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }

  // public checkIfUserNameUsed(username: string): Promise<any> {
  //   let url: string = `${this.apiUrl.baseUrl}account/${username}/inuse`;
  //   return this.http
  //     .get<any>(url, {
  //       headers: {},
  //     })
  //     .toPromise()
  //     .then((resp) => {
  //       return resp;
  //     });
  // }

  public checkNpivailable(npi: string): Promise<any> {
    let url: string = `${this.apiUrl.baseUrl}facility/byFaclityNPI/${npi}`;
    return this.http
      .get<any>(url, {
        headers: {},
      })
      .toPromise()
      .then((resp) => {
        return resp;
      });
  }

  public getAnnouncement(): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}announcement/getAnnouncements`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }
  public getPharmacyList(): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}pharmacy/programPharmacy?dispensingType=2&pharmacyType=2&drugGroupId=1&fulfillmentItemTypeValue=Paid%20Drug`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }

  // Method for Submit patient referral
  public submitPatientPDF(payload: any): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrlDoc.baseUrl}case/enroll/izervayHcpPortal`

    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }

  public docuSignUrl(payload: {
    CaseId: string,
    DocId: string
  }): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrl.baseUrl}portal/docusign/signer`;

    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }


  public getPatientReferralPdf(docId,caseId,username): Observable<any> {
    let t = localStorage.getItem("jwt");
    const host = environment.pdfHost;

    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    // .set("Content-type", "application/json")
    // .set("Accept", "application/pdf");

    let url: string = `${host}/api/v1.1/documents/${username}/${caseId}/${docId}`;
    // return this.http.get(url, {
    //  // headers: this.resHeaders
    //  headers: headers
    // })
    return this.http.get(url, {
      headers: headers,
      responseType: "blob" as "json",
    });
  }

  public getAdminUserDetails(portalAccountId): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}admin/getUsers/${portalAccountId}`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }


  public addFacilityOrProvider(payload: any): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}account/update`;
    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }

  public deleteFacilities(payload, Id): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t)
      .set("Accept", "application/json")
      .set("Content-Type", "application/json")
      // .set("ClientId", "V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH")
      .set("ProgramId", "500034");

    let url: string = ` ${this.apiUrl.baseUrl}portal/account/deleteFacility/${Id}`;

    return this.http.put<any>(url, payload, {
      headers: headers,
    }
    )
  }

  // Update Facilities From Admin Tab
  public updateFacilities(payload): Observable<any> {
    let t = localStorage.getItem("jwt");
    console.log(t);
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t)
      .set("Accept", "application/json")
      .set("Content-Type", "application/json")
      // .set("ClientId", "V5G18lkyJw7nBL3g5RMBK5fgXSf4FFeH")
      .set("ProgramId", "500034");
    console.log(payload);

    let url: string = ` ${this.apiUrl.baseUrl}portal/updateFacility`;

    return this.http.post<any>(url, payload, {
      headers: headers,
    })
  }

  // Admi reset password
  public adminUpdatePwd(payload): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}facilityAccount/password/reset`;

    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }
  // Admi reset Username
  public adminProvideUsername(payload): Observable<any> {

    let url: string = `${this.apiUrl.baseUrl}facilityAccount/password/reset`;

    return this.http.post<any>(url, payload, {});
  }
  // Access permission service
  public provideAccess(payload): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}account/provide/adminAccess`;

    return this.http.post<any>(url, payload, {
      headers: headers,
    });
  }

  public deleteUser(accountId): Observable<any> {
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);

    let url: string = `${this.apiUrl.baseUrl}account/delete/${accountId}`;

    return this.http.put<any>(
      url,
      {},
      {
        headers: headers,
      }
    );
  }
  public refreshTokens(userData: any): Observable<any> {
    let url: string = `${this.apiUrl.baseUrl}account/refreshToken`;
    return this.http.post<any>(url, userData, {
    });
  } public parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('')); return JSON.parse(jsonPayload);
  } public getTime(date: any) {
    const hours = date.getHours();
    // Minutes part from the timestamp
    const minutes = date.getMinutes();
    // Seconds part from the timestamp
    const seconds = date.getSeconds();
    // Will display time in 10:30:23 format
    const formattedTime = hours * 60 * 60 + minutes * 60 + seconds;
    return formattedTime;
  }
  public logout(username: any, jwt): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", "Bearer " + jwt);
    let url: string = `${this.apiUrl.baseUrl}account/logout`;
    return this.http.post<any>(url, username, {
      headers: headers,
    });
  }

  public downloadFile(filePath: string, fileName: string): void {
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName;
    link.click();
    link.remove();
  }

  //payor navigator APIs;
  public getIndications(payload: string): Observable<any>{
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrlDoc.baseUrl}payerNavigator/indications/product?ProductId=${payload}`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }

  public getPayersToState(payload: string): Observable<any> {
    let t = localStorage.getItem('jwt');
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = '';
    if (payload.length) {
      url = `${this.apiUrlDoc.baseUrl}payerNavigator/parents?StateId=${payload}`;
    } else {
      url = `${this.apiUrlDoc.baseUrl}payerNavigator/parents`;
    }
    return this.http.get<any>(url,{ headers: headers,
    });
  }

  public getPlanToPayer(payload: any): Observable<any> {
    let t = localStorage.getItem('jwt');
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string;
    if(payload.state.length){
      url = `${this.apiUrl.baseUrl}payerNavigator/payerPlans?StateId=${payload.state}&ControllerId=${payload.id}&PayerId=${payload.id}&PBMId=${payload.id}`;
    } else {
      url = `${this.apiUrl.baseUrl}payerNavigator/payerPlans?ControllerId=${payload.id}&PayerId=${payload.id}&PBMId=${payload.id}`;
    }
    return this.http.get<any>(url,{ headers: headers});
  }

  public getClaims(payload: any, {page, rows}): Observable<any>{
    let t = localStorage.getItem('jwt');
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrl.baseUrl}payerNavigator/externalClaims?Page=${page}&Limit=${rows}`;
    // let params = new HttpParams()
    //   .set('Page', page.toString())
    //   .set('Limit', rows.toString())
    //   .set('ProductName', payload.ProductName)
    //   .set('Indication', payload.Indication)
    //   .set('State', payload.State)
    //   .set('PlanIds', payload.PlanIds)
    //   .set('ClaimStatusId', payload.ClaimStatusId);
    return this.http.post<any>(url,payload,{headers});
  }

  public getCoverageStatus(payload: any): Observable<any> {
    let t = localStorage.getItem('jwt');
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrlDoc.baseUrl}payerNavigator/medicalCoverage/plan`
    return this.http.post<any>(url,payload,{headers: headers});
  }

  public getPolicyUrl(policyPlanName,selectedPayerName): Observable<any>{
    let t = localStorage.getItem("jwt");
    const headers = new HttpHeaders().set("Authorization", "Bearer " + t);
    let url: string = `${this.apiUrl.baseUrl}payerNavigator/search?PayerName=${selectedPayerName}&PlanName=${policyPlanName}&ProductName=Iveric`;
    return this.http.get<any>(url, {
      headers: headers,
    });
  }


  private handleError(errorRes: string) { 
    let errorMessage = 'An unknown error occurred!';
    if (!errorRes) {
      return throwError(() => errorMessage);
    }
    var status = errorRes.slice(12, 15);
    var errorStatus = Number(status);
    var lastColon = errorRes.lastIndexOf(':');
    if (!errorStatus) {
      return throwError(errorMessage);
    }
    errorMessage = errorRes.slice(lastColon+2,);
    if (errorMessage === "The account is locked"){
      return throwError('The user account has been locked due to multiple failed login attempts.');
    }
    console.log(errorMessage);
    switch (errorStatus) {
      case 400:
        errorMessage = 'The supplied credentials are incorrect';
        break;
      case 403:
        errorMessage = 'The supplied credentials are incorrect';
        break;
      case 500:
        errorMessage = 'Something went wrong. Please try again';
        break;
      case 423:
        errorMessage = 'The account is locked';
    }
    return throwError(errorMessage);
  }
}
